import React, { Component } from 'react';
import CoffeeTracker from './components/CoffeeTracker'
import moment from 'moment';

class PoliDone extends Component {
  constructor(props) {
    super(props);
    this.state = { order: null }
    fetch('/api/order/poli/'+this.props.orderId + (
        this.props.status === 'done' ? '' : ('/' + this.props.status)
      ) + '?token=' + this.props.token, {
        credentials: 'include',
        method: 'POST'
      }
    )
    .then(res => res.json() )
    .then(order=>{
      if(order.ErrorMessage){
        console.log(222, order, order.ErrorMessage)
        return this.setState({error: order.ErrorMessage})
      }
      let date = moment(order.date)
      order.date = {
        name: date.format('dddd'),
        date: date
      }
      this.setState({order: order})
    })
  }


  getItems(){
    var order = this.state.order
    return order.items.map((item, i)=>
      <tr key={i}>
        <td>
          {item.food}
          { order.type === 'coffee' ? (' - ' + item.size) : null }
          {  ' - ' + item.person }
        </td>
        {item.time ? <td>{item.time}</td> : null}
        <td>${this.toCurrency(item.price)}</td>
        { order.type === 'coffee' ? null :
          <td>{item.count}</td> }
      </tr>
    )
  }

  getSubTotal(){
    return this.state.order.items.reduce((x, y)=>x+ y.price*y.count, 0)
  }

  getSurcharge(){
    var stot = this.getSubTotal();
    if(this.state.order.payment === 'poli')
      return stot * 0.01
    return (stot + 0.3)/(1-0.029) - stot
  }

  getTotal(){
    return this.getSurcharge() + this.getSubTotal();
  }

  getSurchargeName(){
    return this.state.order.payment === 'poli' ?
      'Internet Banking' :
      'Credit / Debit Card';
  }

  toCurrency(num){
    return (Math.ceil(num * 100) / 100).toFixed(2)
  }

  getTitle(status){
    switch(status){
      case 'done':
        return 'Order Confirmation';
      case 'cancel':
        return 'Payment Cancelled';
      case 'failure':
      default:
        return 'Payment Failure';
    }
  }

  render() {
    if(this.state.error)
      return (<div className="alert alert-danger">{this.state.error}</div>);
    if(!(this.state.order && this.state.order.customer)) return (<h1>Loading...</h1>);

    return (
      <div className="">
        <h1>{this.getTitle(this.props.status)}</h1>
        { this.state.order.type === 'coffee' ? (
          <p>{this.state.order.customer.name} - {this.state.order.customer.school.name}</p>
        ) : (
          <p>{this.state.order.date.name}</p>
        )}

        { this.state.order.type === 'coffee' && this.props.status === 'done' ?
          <CoffeeTracker schoolId={this.state.order.customer.school.id}
            orderId={this.state.order.id} /> : null }

        <table className="table">
          <thead>
            <tr>
              <th>For</th>
              <th>Item</th>
              <th>Price</th>
              { this.state.order.type === 'coffee' ? null :
                <th>Quantity</th> }
            </tr>
          </thead>
          <tbody>
            { this.getItems() }
          </tbody>
        </table>

        <div className="text-center">
          <p>{this.getSurchargeName()} Surcharge: ${this.toCurrency(this.getSurcharge())}</p>
          <h2>Order Total ${this.toCurrency(this.getTotal())}</h2>
          {this.props.status === 'done' ? (
            <h2>Your order has been placed! Thank you</h2>
          ) : (
            <h2>Your order failed. Please try again.</h2>
          )}
        </div>
      </div>
    );
  }
}

export default PoliDone;



// WEBPACK FOOTER //
// ./src/pages/PoliDone.js